import React, { useState, useEffect } from 'react'
import CAMenuView from './CAMenuView'
import ChatMessageKit from '../../../../data/ChatMessageKit'
import ChatModeratorKit from '../../../../data/ChatModeratorKit'
import AnnouncementKit from '../../../../data/AnnouncementKit'

export default function CorporateAgentMenu({
  me,
  urlParams,
  eventUserAvailabilityList,
}) {

  const announcementKit = new AnnouncementKit()
  const [showInviteBackButton, setShowInviteBackButton] = useState(false)
  const [isTrashed, setIsTrashed] = useState(false)

  useEffect(() => {
    const cleanup = ChatMessageKit.getCorporateChatIsTrashed({
      ...urlParams,
      onChange: (snapshot) => {
        setIsTrashed(snapshot.val())
      }
    })

    return () => cleanup()

  }, [])

  function toggleIsTrashed() {
    ChatMessageKit.setCorporateChatIsTrashed({
      ...urlParams,
      isTrashed: !isTrashed
    })
  }

  function downloadCorporateSingleChatCSV() {
    ChatModeratorKit.downloadCorporateSingleChatMessagesCSV(urlParams)
      .then(res => {
        const filename = res.headers['content-disposition'].split('=')[1]
        const file = new File([res.data], filename, { type: 'text/csv;charset=UTF-8' });
        const fileUrl = window.URL.createObjectURL(file);
        window.location.assign(fileUrl);
      })
  }

  async function sendAnnouncementToEventUser(message) {
    const data = {
      eventUserIds: [urlParams.eventUserId],
      pageSlug: urlParams.pageSlug,
      description: message
    }
    const response = await announcementKit.agentInviteMessage(data)
  }

  useEffect(() => {
    const availability = eventUserAvailabilityList?.[urlParams.eventUserId] ?? 0

    setShowInviteBackButton(availability === 0)
  }, [eventUserAvailabilityList])

  return (
    <CAMenuView
      me={me}
      isTrashed={isTrashed}
      toggleIsTrashed={toggleIsTrashed}
      showInviteBackButton={showInviteBackButton}
      downloadCorporateSingleChatCSV={downloadCorporateSingleChatCSV}
      sendAnnouncementToEventUser={sendAnnouncementToEventUser}
    />
  )
}
